// Lumi ürün sayfası: Horizon varyant değişiminde gelen yeni HTML'den [data-lm-live] alanlarını (fiyat, tasarruf, stok) günceller.
import { StandardEvents } from '@shopify/events';

document.addEventListener(
  StandardEvents.productSelect,
  (event) => {
    if (!event.promise) return;
    event.promise
      .then(({ detail }) => {
        if (!detail || !detail.html) return;
        document.querySelectorAll('[data-lm-live]').forEach((el) => {
          const fresh = detail.html.querySelector(`[data-lm-live="${el.dataset.lmLive}"]`);
          if (fresh) el.innerHTML = fresh.innerHTML;
        });
      })
      .catch(() => {});
  },
  true
);
